// ================================================================
// PROPRIETARY & CONFIDENTIAL — Miskulin Technologies Inc.
// Copyright (c) 2026 Miskulin Technologies. All rights reserved.
// ================================================================
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import DemoManagementPage from './pages/DemoManagementPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import SignUpPage from './pages/SignUpPage';
import './App.css';
import { ToastProvider } from './shared/Toast';
import './shared/modern-ux.css';

function App() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <p>Loading...</p>
      </div>
    );
  }

  return (
<ToastProvider position="top-right">
<Routes>
      <Route path="/signup" element={<SignUpPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/demo" element={<DemoManagementPage />} />
      <Route path="*" element={<Navigate to="/signup" replace />} />
    <Route path="/demo-management" element={<ProtectedRoute><DemoManagementPage /></ProtectedRoute>} />

    </Routes>
  </ToastProvider>
  );
}

export default App;
